import PageBreadcrumbs from "@insite/content-library/Components/PageBreadcrumbs";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import Page from "@insite/mobius/Page";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { ReactNode } from "react";
import { css } from "styled-components";
import styled from "styled-components";

interface PageLayoutProps {
    showHeader: boolean;
    header: ReactNode;
    showCompactHeader: boolean;
    compactHeader: ReactNode;
    showBreadcrumbs: boolean;
    pageContent: ReactNode;
    showFooter: boolean;
    footer: ReactNode;
    showSignInOverlay?: boolean;
    signInOverlay?: ReactNode;
}

export interface PageLayoutStyles {
    wrapper?: InjectableCss;
    wrapperNoPadding?: InjectableCss;
    breadcrumbWrapper?: InjectableCss;
}

export const pageLayoutStyles: PageLayoutStyles = {
    wrapper: {
        css: css`
            min-height: 500px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                    padding-top: 0;
                `,
                    css`
                    padding-top: 0;
                `,
                    css`
                    padding-top: 153px;
                `,
                    css`
                    padding-top: 141px;
                `,
                    css`
                    padding-top: 141px;
                `,
                ])}
        `,
    },
    wrapperNoPadding: {
        css: css`
            min-height: 500px;
            padding: 0 0 0 0;
        `,
    },
    breadcrumbWrapper: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                    padding-top: 15px;
                    @media print {
                        padding-top: 0px;
                    }
                `,
                    css`
                    padding-top: 15px;
                    @media print {
                        padding-top: 0px;
                    }
                `,
                    css`
                    padding-top: 165px;
                    @media print {
                        padding-top: 0px;
                    }
                `,
                    css`
                    padding-top: 156px;
                    @media print {
                        padding-top: 0px;
                    }
                `,
                    css`
                    padding-top: 156px;
                    @media print {
                        padding-top: 0px;
                    }
                `,
                ])}
        `,
    },
};

const styles = pageLayoutStyles;

// This doesn't currently support HMR
const PageLayout = ({
    showHeader,
    header,
    showBreadcrumbs,
    pageContent,
    showFooter,
    footer,
    showCompactHeader,
    compactHeader,
    showSignInOverlay,
    signInOverlay,
}: PageLayoutProps) => {
    return (
        <PageLayoutWrapper>
            {showHeader && header}
            {showCompactHeader && compactHeader}
            {showBreadcrumbs && (
                <Page as="div"
                    {...(showBreadcrumbs ? { ...styles.breadcrumbWrapper } : undefined)}>
                    <PageBreadcrumbs />
                </Page>
            )}
            {pageContent && (
                <Page
                    as="section"
                    fullWidth={[true, true, true, true, true]}
                    {...(!showBreadcrumbs ? { ...styles.wrapper } : { ...styles.wrapperNoPadding })}
                >
                    {pageContent}
                </Page>
            )}
            {showFooter && footer}
            {showSignInOverlay && signInOverlay}
        </PageLayoutWrapper>
    );
};

const PageLayoutWrapper = styled.div`
    display: flex;
    min-height: 100vh;
    flex-direction: column;
    > main {
        flex: 1 1 0%;
    }

    @media print {
        display: block;
    }
`;

export default PageLayout;
